import { Building2, Users, Briefcase, Rocket, ArrowRight, Check } from "lucide-react";
import { Container, Reveal, SectionHeader } from "./common";

const industries = [
    {
        icon: Building2,
        name: "Real Estate",
        testid: "solution-card-real-estate",
        workflow: ["Lead", "Site Visit", "Negotiation", "Booking", "Agreement", "Closed"],
        features: ["Property inventory", "Site visits", "Broker management", "Follow-ups", "Bookings"],
    },
    {
        icon: Users,
        name: "Staffing & Recruitment",
        testid: "solution-card-staffing",
        workflow: ["Requirement", "Candidate", "Submission", "Interview", "Offer", "Placement"],
        features: ["Client management", "Requirements", "Candidate pipeline", "Interview tracking", "Placement tracking"],
    },
    {
        icon: Briefcase,
        name: "B2B Sales",
        testid: "solution-card-b2b",
        workflow: ["Lead", "Qualification", "Discovery", "Proposal", "Negotiation", "Won"],
        features: ["Account management", "Opportunity tracking", "Quotations", "Sales forecasting"],
    },
    {
        icon: Rocket,
        name: "Growing Businesses",
        testid: "solution-card-growing-biz",
        workflow: ["Lead", "Follow-up", "Opportunity", "Proposal", "Customer"],
        features: ["Easy setup", "Better follow-ups", "Simple CRM", "Scalable workflows"],
    },
];

const Industries = () => (
    <section id="industries" data-testid="industry-solutions-section" className="bg-white py-20 lg:py-28">
        <Container>
            <SectionHeader
                eyebrow="Solutions"
                title="CRM that adapts to your business."
                sub="Start with a workflow that matches your industry — then shape every stage, field and automation around how your team actually sells."
            />
            <div className="mt-14 grid gap-5 md:grid-cols-2">
                {industries.map((ind, i) => (
                    <Reveal key={ind.name} delay={(i % 2) * 0.08}>
                        <article
                            data-testid={ind.testid}
                            className="group h-full rounded-2xl border border-[#E5E7EB] bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#16A34A]/30 hover:shadow-xl hover:shadow-[#16A34A]/[0.06]"
                        >
                            <div className="flex items-center gap-3.5">
                                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#F0FDF4] transition-colors group-hover:bg-[#16A34A]">
                                    <ind.icon className="h-5 w-5 text-[#16A34A] transition-colors group-hover:text-white" />
                                </span>
                                <h3 className="font-display text-xl font-bold text-[#111827]">{ind.name}</h3>
                            </div>

                            {/* workflow */}
                            <div className="mt-6 flex flex-wrap items-center gap-y-2">
                                {ind.workflow.map((step, si) => (
                                    <span key={step} className="flex items-center">
                                        <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${si === ind.workflow.length - 1 ? "bg-[#16A34A] text-white" : "bg-[#F0FDF4] text-[#15803D]"}`}>
                                            {step}
                                        </span>
                                        {si < ind.workflow.length - 1 && (
                                            <ArrowRight className="mx-1 h-3 w-3 text-[#94A3B8]" />
                                        )}
                                    </span>
                                ))}
                            </div>

                            <ul className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-2">
                                {ind.features.map((f) => (
                                    <li key={f} className="flex items-center gap-2 text-[13px] font-medium text-[#475569]">
                                        <Check className="h-3.5 w-3.5 shrink-0 text-[#16A34A]" />
                                        {f}
                                    </li>
                                ))}
                            </ul>
                        </article>
                    </Reveal>
                ))}
            </div>
        </Container>
    </section>
);

export default Industries;
